import { useEffect } from "react";
import type { Slide } from "../types";
import { CloseIcon } from "./icons";

/** Lightbox that shows the complete (uncropped) image of a carousel slide. */
export function ImageModal({
	slide,
	onClose,
}: {
	slide: Slide | null;
	onClose: () => void;
}) {
	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [onClose]);

	return (
		<div className={`image-modal-overlay${slide ? " open" : ""}`} onClick={onClose}>
			<button className="image-modal__close" onClick={onClose} aria-label="Cerrar">
				<CloseIcon />
			</button>
			<div className="image-modal" onClick={(e) => e.stopPropagation()}>
				{slide && <img src={slide.src} alt={slide.label || ""} />}
				{slide?.label && <div className="image-modal__caption">{slide.label}</div>}
			</div>
		</div>
	);
}
